import React, { useState, useEffect } from "react";
// import { Select } from "antd";
import { useDispatch, useSelector } from "react-redux";
import AccountActions from "../../../redux/actions/account.actions";
import customerSelector from "../../../redux/selectors/customer.selector";
// import {
//   getCountries,
//   getCountryCallingCode,
// } from "react-phone-number-input/input";
// import en from "react-phone-number-input/locale/en.json";
import PhoneNumberInput from "../../custom/PhoneNumberInput";

// const { Option } = Select;
const AccountInfo = ({ isCheckoutPage, customerInfo, isGuest, updateCustomerData, customerData, customerErrorInfo, updateCustomerErrorInfo }) => {
  const [isEditing, setIsEditing] = useState(false);
  const dispatch = useDispatch();
  const isCustomerInfoBeingUpdated = useSelector(
    customerSelector.isCustomerInfoBeingUpdated,
  );

  useEffect(() => {
    if (!isCustomerInfoBeingUpdated) {
      setIsEditing(false);
    }
  }, [isCustomerInfoBeingUpdated]);

  useEffect(() => {
    updateCustomerData({ ...customerInfo });
  }, [customerInfo]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    updateCustomerErrorInfo({})
    updateCustomerData((prev) => ({ ...prev, [name]: value }));
  };

  const handleUpdate = (e) => {
    e.preventDefault();
    dispatch(
      AccountActions.updateCustomerInfoAction(
        {
          firstName: customerData?.firstName,
          lastName: customerData?.lastName,
          email: customerData?.email,
        },
        customerInfo?.customerId,
      ),
    );
  };
  const isFieldReadOnly = !isEditing && !isCheckoutPage && !isGuest;
  
  return (
    <section className="section-card info-section">
      <div className="section-header-row">
        <h2 className="section-title">Personal Details</h2>
        {!isCheckoutPage && (
          <button
            className={`edit-btn ${isEditing ? "cancel" : ""}`}
            onClick={() => setIsEditing(!isEditing)}
          >
            {isEditing ? "Cancel" : "Edit Details"}
          </button>
        )}
      </div>

      <form
        onSubmit={handleUpdate}
        className={`account-info-form ${isEditing ? "editing" : ""}`}
      >
        <div className="form-grid">
          <div className="input-group">
            <label className={`input-label ${isCheckoutPage ? 'mobile-required' : ''}`}>First Name</label>
            <input
              type="text"
              name="firstName"
              value={
                isGuest && isCheckoutPage && !customerData?.firstName
                  ? undefined
                  : customerData?.firstName
              }
              onChange={handleChange}
              readOnly={isFieldReadOnly}
              required
              className={`input-field ${isFieldReadOnly ? "readonly-look" : ""}`}
              placeholder="Enter first name"
            />
            {isCheckoutPage && customerErrorInfo?.firstName && (
                <div className="errormsg">{customerErrorInfo?.firstName}</div>
            )}
          </div>
          <div className="input-group">
            <label className={`input-label ${isCheckoutPage ? 'mobile-required' : ''}`}>Last Name</label>
            <input
              type="text"
              name="lastName"
              value={
                isGuest && isCheckoutPage && !customerData?.lastName
                  ? undefined
                  : customerData?.lastName
              }
              onChange={handleChange}
              readOnly={isFieldReadOnly}
              required
              className={`input-field ${isFieldReadOnly ? "readonly-look" : ""}`}
              placeholder="Enter last name"
            />
            {isCheckoutPage && customerErrorInfo?.lastName && (
                <div className="errormsg">{customerErrorInfo?.lastName}</div>
            )}
          </div>
          <div className="input-group">
            <label className={`input-label ${isCheckoutPage ? 'mobile-required' : ''}`}>Email Address</label>
            <input
              type="email"
              name="email"
              value={
                isGuest && isCheckoutPage && !customerData?.email
                  ? undefined
                  : customerData?.email
              }
              onChange={handleChange}
              readOnly={isFieldReadOnly}
              required
              className={`input-field ${isFieldReadOnly ? "readonly-look" : ""}`}
              placeholder="email@example.com"
            />
            {isCheckoutPage && customerErrorInfo?.email && (
                <div className="errormsg">{customerErrorInfo?.email}</div>
            )}
          </div>
          <div className="input-group">
            <label className="input-label">Mobile</label>
            {/* <div style={{ display: "flex" }}>
              {content}

              <input
                type="text"
                name="mobile"
                value={
                  isGuest && isCheckoutPage && !customerData?.mobile
                    ? ""
                    : `${customerData?.mobile}`
                }
                onChange={handleChange}
                // readOnly={isFieldReadOnly}
                // required}
                // readOnly={!isGuest}
                // disabled={!isGuest}
                className="input-field"
              />
            </div> */}
            <PhoneNumberInput 
              value={isGuest && isCheckoutPage && !customerData?.mobile ? "" : `${customerData?.mobile}`}
              disabled={(isCheckoutPage && isGuest) ? false : true}
              callback={updateCustomerData}
              countryCode={customerData?.countryCode}
              updateInput={handleChange}
            />
            {!isCheckoutPage && (
              <span className="helper-text">
                Contact support to change mobile number.
              </span>
            )}
          </div>
        </div>

        {isEditing && (
          <div className="form-actions">
            <button
              className="btn-save-details"
              type="submit"
              disabled={isCustomerInfoBeingUpdated}
              style={{ marginTop: "1.5rem", padding: "0.8rem" }}
            >
              {isCustomerInfoBeingUpdated ? "Updating..." : "Save Changes"}
            </button>
          </div>
        )}
      </form>
    </section>
  );
};
export default AccountInfo;
